import debounce from "debounce-promise";
import { transformToSearchResults, } from "../Infra/fasten.search.dtos";
import { getFastenApiMode, getFastenPublicId } from "../Infra/FastenSearchService";
export class FastenSearchManager {
    constructor(fastenSearchService, environment, authManager) {
        this.fastenSearchService = fastenSearchService;
        this.environment = environment;
        this.authManager = authManager;
        this.search = debounce(async (query, filters, searchAfter) => {
            try {
                const fastenApiMode = getFastenApiMode(this.authManager.isSandbox);
                const fastenPublicId = getFastenPublicId(this.authManager.isSandbox, this.environment);
                const response = await this.fastenSearchService.search(query, fastenApiMode, fastenPublicId, filters, searchAfter);
                return transformToSearchResults(response, this.environment);
            }
            catch (error) {
                console.error(error);
                return { results: [], nextCursor: null, totalHits: 0 };
            }
        }, 300);
    }
}
